import { BaseContainerModel } from "../base-container.model";
import {
  bl_mkp_seller_allocation_queue_Rowinterface,
  bl_mkp_seller_allocation_queue_Rowclass,
} from "../../dbschema/index";

export class SellerAllocationQueueModel extends BaseContainerModel {
  bl_mkp_seller_allocation_queue: bl_mkp_seller_allocation_queue_Rowinterface =
    new bl_mkp_seller_allocation_queue_Rowclass();
} 
